import { render, staticRenderFns } from "./RiskByOrgLevel.vue?vue&type=template&id=7681acfb&"
import script from "./RiskByOrgLevel.vue?vue&type=script&lang=js&"
export * from "./RiskByOrgLevel.vue?vue&type=script&lang=js&"
import style0 from "./RiskByOrgLevel.vue?vue&type=style&index=0&id=7681acfb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports